import React from 'react';
import styled from 'styled-components';
import modalBuilder from '~/hoc/modalBuilder';

const MODAL_NAME = 'PENDENCIES';

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  border-radius: 4px;
`;

const ListItem = styled.li`
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.primary};
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }
`;

type PendenciesProps = {
  pendencies: string[];
};

function Pendencies({ pendencies }: PendenciesProps) {
  return (
    <List>
      {pendencies.map((item, i) => (
        <ListItem key={i}>{item}</ListItem>
      ))}
    </List>
  );
}

export default modalBuilder(Pendencies, MODAL_NAME, {
  title: 'Status lógico',
  centered: true,
});
